// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

const dummyProductData: { product: any; productInfo: any } = {
    product: {
        uri: "http://hardwoods.local.com/api/v2/products/aba66a89-3415-4b19-8c95-9cf600f2e899",
        id: "aba66a89-3415-4b19-8c95-9cf600f2e899",
        productNumber: "GWP232323",
        customerProductNumber: null,
        productTitle: "Anti-Fog Goggle Wipes",
        urlSegment: "GWP232323",
        canonicalUrl: "/Product/GWP232323",
        manufacturerItem: "",
        packDescription: "",
        unitListPrice: 2,
        unitListPriceDisplay: "$2.00",
        priceFacet: 0,
        smallImagePath: "",
        mediumImagePath: "",
        largeImagePath: "",
        imageAltText: "",
        isDiscontinued: false,
        quoteRequired: false,
        minimumOrderQty: 0,
        isSponsored: false,
        trackInventory: false,
        configurationType: "None",
        canConfigure: false,
        canAddToCart: true,
        canAddToWishlist: true,
        canShowPrice: true,
        canShowUnitOfMeasure: true,
        isVariantParent: false,
        variantTypeId: null,
        brand: null,
        productLine: null,
        unitOfMeasures: [
            {
                id: "00000000-0000-0000-0000-000000000000",
                unitOfMeasure: "EA",
                unitOfMeasureDisplay: "EA",
                description: "",
                qtyPerBaseUnitOfMeasure: 1,
                roundingRule: "No Rounding",
                isDefault: true,
            },
        ],
        attributeTypes: [
            {
                id: "411ba81a-0a99-420e-a7a2-acce00565646",
                name: "[Cell Title Example]",
                label: "[Cell Title Example]",
                isFilter: true,
                isComparable: true,
                isSearchable: true,
                includeOnProduct: true,
                sortOrder: 0,
                attributeValues: [
                    {
                        id: "29fa3bb6-a68a-4a7e-b5ae-b274014182c8",
                        value: "[Data Cell Example Content]",
                        valueDisplay: "[Data Cell Example Content]",
                        sortOrder: 0,
                    },
                ],
            },
            {
                id: "d041a7ad-603a-4729-b272-acce00565718",
                name: "[Cell Title Example]",
                label: "[Cell Title Example]",
                isFilter: true,
                isComparable: true,
                isSearchable: true,
                includeOnProduct: true,
                sortOrder: 1,
                attributeValues: [
                    {
                        id: "30f15021-2b70-4dab-8de0-b2740141a6ea",
                        value: "[Data Cell Example Content]",
                        valueDisplay: "[Data Cell Example Content]",
                        sortOrder: 0,
                    },
                ],
            },
            {
                id: "3087bb86-26f4-440a-a347-acce005656f7",
                name: "[Cell Title Example On Two Lines]",
                label: "[Cell Title Example On Two Lines]",
                isFilter: true,
                isComparable: true,
                isSearchable: true,
                includeOnProduct: true,
                sortOrder: 2,
                attributeValues: [
                    {
                        id: "b68edf70-1b42-4c8c-ad0d-b2740141bd06",
                        value: "[Data Cell Example Content]",
                        valueDisplay: "[Data Cell Example Content]",
                        sortOrder: 0,
                    },
                ],
            },
            {
                id: "324b1c02-e5a2-47e3-888a-acce00565690",
                name: "[Cell Title Example]",
                label: "[Cell Title Example]",
                isFilter: true,
                isComparable: true,
                isSearchable: true,
                includeOnProduct: true,
                sortOrder: 3,
                attributeValues: [
                    {
                        id: "dc3a163f-87fa-4837-b2f7-b2740141bfef",
                        value: "[Data Cell Example Content That Is Super Long and Necessitates Going on Two Lines]",
                        valueDisplay:
                            "[Data Cell Example Content That Is Super Long and Necessitates Going on Two Lines]",
                        sortOrder: 0,
                    },
                ],
            },
        ],
        properties: { badge: "Blue Badge" },
    },
    productInfo: {
        productId: "aba66a89-3415-4b19-8c95-9cf600f2e899",
        qtyOrdered: 1,
        unitOfMeasure: "EA",
        productDetailPath: "/Catalog/Ancillary-Sales/GWP232323",
        inventory: {
            productId: "aba66a89-3415-4b19-8c95-9cf600f2e899",
            qtyOnHand: 0,
            inventoryAvailabilityDtos: [
                {
                    unitOfMeasure: "EA",
                    availability: {
                        messageType: 0,
                        message: null,
                        requiresRealTimeInventory: false,
                    },
                },
            ],
            inventoryWarehousesDtos: [],
            additionalResults: {},
        },
        pricing: {
            productId: "aba66a89-3415-4b19-8c95-9cf600f2e899",
            isOnSale: false,
            requiresRealTimePrice: false,
            additionalResults: {},
            unitCost: 0,
            unitCostDisplay: null,
            unitListPrice: 2,
            unitListPriceDisplay: "$2.00",
            extendedUnitListPrice: 2,
            extendedUnitListPriceDisplay: "$2.00",
            unitRegularPrice: 2,
            unitRegularPriceDisplay: "$2.00",
            extendedUnitRegularPrice: 2,
            extendedUnitRegularPriceDisplay: "$2.00",
            unitNetPrice: 2,
            unitNetPriceDisplay: "$2.00",
            extendedUnitNetPrice: 2,
            extendedUnitNetPriceDisplay: "$2.00",
            unitOfMeasure: "EA",
            unitListBreakPrices: [],
            unitRegularBreakPrices: [],
            regularPrice: 2,
            regularPriceDisplay: "$2.00",
            extendedRegularPrice: 2,
            extendedRegularPriceDisplay: "$2.00",
            actualPrice: 2,
            actualPriceDisplay: "$2.00",
            extendedActualPrice: 2,
            extendedActualPriceDisplay: "$2.00",
            regularBreakPrices: [],
            actualBreakPrices: [],
        },
    },
};

export const dummyProductContext = {
    product: dummyProductData.product,
    productInfo: dummyProductData.productInfo,
    onUnitOfMeasureChanged: () => { },
    onQtyOrderedChanged: () => { },
};
